import { createAppSelector } from 'wanderu-ducks-utils';

import { serializePredictionParams } from '../actions/utils';
import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

function _dataSelector(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function _predictionSelector(data, id) {
    return data.predictions[id];
}

function _topPredictionSelector(predictions = []) {
    return predictions[0];
}

function _placeDetailsSelector(data, placeId) {
    return data.placeDetails[placeId];
}

const selectPlaceDetails = createAppSelector(
    [
        _dataSelector,
        (_, placeId) => placeId,
    ],
    _placeDetailsSelector,
);

const _selectPredictions = createAppSelector(
    [
        _dataSelector,
        (_, id) => id,
    ],
    _predictionSelector,
);

function selectPredictions(appState, predictionParams) {
    const id = serializePredictionParams(predictionParams);
    return _selectPredictions(appState, id);
}

const _selectTopPrediction = createAppSelector(
    [(state, id) => _selectPredictions(state, id)],
    _topPredictionSelector,
);

function selectTopPrediction(appState, predictionParams) {
    const id = serializePredictionParams(predictionParams);
    return _selectTopPrediction(appState, id);
}

const selectLatLongData = createAppSelector(
    [selectPlaceDetails],
    (place) => ({
        latitude: place?.geometry?.location?.lat,
        longitude: place?.geometry?.location?.lng,
    }),
);

export {
    selectLatLongData,
    selectPlaceDetails,
    selectPredictions,
    selectTopPrediction,
};
